import { signalStoreFeature } from '@ngrx/signals';
import { withEventHandlers } from '@ngrx/signals/events';

export function withPositionAndWeatherEffects() {
  return signalStoreFeature(
    withEventHandlers(() => {
      return {};
    })
  );
}
